import React from 'react'
import CollapsibleCard from '../components/CollapsibleCard'
import { useGetAlertsQuery, useGetFreshnessQuery } from '../saberApi'
import EngineStatus from './EngineStatus'
import Health from './Health'
import { useStickyPanelOffset } from '../useStickyPanelOffset'

// v001 Config tab (BEHAVIOR_SPEC §11): Engine Status (run-control dashboard)
// followed by the Data health content collapsed inside a CollapsibleCard.
export const Config: React.FC = () => {
  const { pageHeaderRef, panelStickyProps } = useStickyPanelOffset()

  // Row counts for the collapsed summary — same queries Health uses, so RTK
  // Query serves both from one cache entry.
  const { data: freshness } = useGetFreshnessQuery()
  const { data: alerts } = useGetAlertsQuery()
  const summary = `${freshness?.length ?? 0} sources · ${alerts?.length ?? 0} alerts`

  return (
    <div className="space-y-4 pb-4">
      <div
        ref={pageHeaderRef}
        className="sticky top-0 z-10 -mx-4 space-y-1 border-b border-slate-200 bg-white px-4 py-2.5 dark:border-slate-700 dark:bg-slate-900 sm:-mx-6 sm:px-6 md:-mx-8 md:px-8"
      >
        <div className="flex flex-wrap items-baseline gap-x-2 gap-y-1">
          <h2 className="m-0 text-lg font-semibold text-slate-900 dark:text-slate-100">Engine Status</h2>
          <p className="m-0 text-xs text-slate-500 dark:text-slate-400">
            SABER run control — queue, run history, and schedules (read-only).
          </p>
        </div>
      </div>
      <EngineStatus panelStickyProps={panelStickyProps} />
      <CollapsibleCard
        title="Data health — source freshness & alerts"
        defaultOpen={false}
        summary={summary}
        {...panelStickyProps(4)}
      >
        <Health embedded panelStickyProps={panelStickyProps} stickyZIndexStart={5} />
      </CollapsibleCard>
    </div>
  )
}

export default Config
